import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { useDigitalTwinsStore } from './digital-twins'
import type { BasicDigitalTwin } from 'models/BasicDigitalTwin'

export const useSelectedStore = defineStore('selected', () => {
  /** Currently selected digital twin ids */
  const selectedIds = ref<string[]>([])
  /** Current page not index (index = drawerPage - 1) */
  const drawerPage = ref(1)

  /** Selected digital twins from store */
  const selected = computed(() => useDigitalTwinsStore().twinsByIds(selectedIds.value))

  /** Check if digital twin is selected by id */
  function isSelected(id: string): boolean {
    return selectedIds.value.includes(id)
  }

  /** Drawer selected digital twin from store */
  const drawerSelected = computed(() => {
    if (selectedIds.value.length < drawerPage.value) {
      drawerPage.value = 1
    }
    return useDigitalTwinsStore().twinsByIds(selectedIds.value)[drawerPage.value - 1]
  })

  /** Drawer selected digital twin Id */
  const drawerSelectedId = computed(() => {
    if (selectedIds.value.length < drawerPage.value) {
      drawerPage.value = 1
    }
    return selectedIds.value[drawerPage.value - 1]
  })

  /** Set single selected digital twin by id */
  function setSelectedById(twinId: string) {
    // reset drawerPage
    drawerPage.value = 1
    selectedIds.value = [twinId]
  }

  /** Set multiple selected digital twins by ids */
  function setSelectedByIds(twinIds: string[]) {
    // only reset if drawerPage is higher the amount of twinIds
    if (twinIds.length < drawerPage.value) {
      drawerPage.value = 1
    }
    selectedIds.value = twinIds
  }

  /** Set multiple selected digital twins by collection of digital twins */
  function setSelected(selectedTwins: BasicDigitalTwin[]) {
    // only reset if drawerPage is higher the amount of selectedTwins
    if (selectedTwins.length < drawerPage.value) {
      drawerPage.value = 1
    }
    selectedIds.value = selectedTwins.map((x: BasicDigitalTwin) => x.$dtId)
  }

  return {
    selectedIds,
    drawerPage,
    selected,
    isSelected,
    drawerSelected,
    drawerSelectedId,
    setSelectedById,
    setSelectedByIds,
    setSelected
  }
})
